import { MetadataLoadingStage } from "./services/user-context.service";

export interface OrganizationRoleRouteAccess {
    name: string;
    path: string;
    requiresOwner?: boolean;
    requiresAdmin?: boolean;
    requiresInternalSuperAdmin?: boolean;
    metadataLoadingStage?: MetadataLoadingStage;
}

export const ORGANIZATION_ROLE_ROUTE_ACCESS: OrganizationRoleRouteAccess[] = [
    { path: 'profile', name: 'Profile' , requiresOwner: false, requiresAdmin: false },
    { path: 'organizations', name: 'Organizations', requiresOwner: false, requiresAdmin: false },
    { path: 'team', name: 'Team', requiresOwner: false, requiresAdmin: true },
    { path: 'subscription-list', name: 'Subscriptions', requiresOwner: false, requiresAdmin: true },
    // { path: 'security', name: 'Security', requiresOwner: false, requiresAdmin: true, show: () => this.metadataLoadingStage >= MetadataLoadingStage.OrganizationLoaded },
    { path: 'instance-list', name: 'Instances', requiresOwner: false, requiresAdmin: true },
    { path: 'connectors', name: 'Connectors', requiresOwner: false, requiresAdmin: true },
    { path: 'internal-admin', name: 'Internal Admin', requiresOwner: false, requiresAdmin: true, requiresInternalSuperAdmin: true },
];
